<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>鸿图归来运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加开区红包</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="main-border" style="width: 400px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户ID" prop="addUserId">
          <el-input size="small" v-model="form.addUserId" disabled></el-input>
        </el-form-item>
        <el-form-item label="发放区服" prop="serverId">
          <el-autocomplete
              v-model="serverName"
              size="small"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="红包名称" prop="redName">
          <el-input size="small" v-model="form.redName" placeholder="请输入红包名称"></el-input>
        </el-form-item>
        <el-form-item label="红包个数" prop="num">
          <el-input size="small" v-model="form.num" placeholder="请输入红包个数"></el-input>
        </el-form-item>
        <el-form-item label="红包总金额" prop="money">
          <el-input size="small" v-model="form.money" placeholder="请输入红包总金额"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">添加红包</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {addOpenZoneRed,queryServer} from '@/api/request';
export default {
  name: "openZoneAdd",
  data(){
    return {
      restaurants: [],
      serverName: '',
      form:{
        addUserId: '',
        serverId: '',
        redName: '',
        num: 1,
        money: ''
      },
      rules: {
        redName: [{ required: true, message: '请输入红包名称', trigger: 'blur' }],
        serverId: [{ required: true, message: '请选择区服名称', trigger: 'blur' }],
        num: [{ required: true, message: '请输入红包数', trigger: 'blur' }],
        money: [{ required: true, message: '请输入红包金额', trigger: 'blur' }],
      }
    }
  },
  mounted() {
    this.loadAll();
    let user = JSON.parse(localStorage.getItem("userInfo"));
    this.form.addUserId = user.adminId;
  },
  methods:{
    onSubmit(){
      addOpenZoneRed(this.form).then(res => {
        if (res.data.success) {
          this.$message.success('开区红包添加成功')
        } else {
          this.$message.error(res.data.error.message);
        }
        this.form = {
          serverId: '',
          redName: '',
          num: 1,
          money: ''
        }
        this.serverName = '';
      })
    },
    querySearchAsync(queryString, cb){
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item){
      this.form.serverId = item.serverCode;
    },
    loadAll(){
      let me = this;
      queryServer().then(res => {
        me.restaurants = [];
        res.data.data.forEach(function (e) {
          let item = {};
          item.value = e.server_name;
          item.serverCode = e.server_code;
          me.restaurants.push(item);
        })
        
      })
    },
  }
}
</script>

<style scoped>

</style>